import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function EmergencyRoadsidePage() {
  return <div data-id="element-987">
      {/* Page Header */}
      <div className="bg-[#822433] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-988">
        <p className="text-red-200 font-bold text-sm uppercase tracking-widest mb-3" data-id="element-989">
          24/7 Service
        </p>
        <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-990">
          🚨 Emergency Roadside Assistance
        </h1>
        <p className="text-red-100 text-base mt-4 max-w-xl mx-auto" data-id="element-991">
          Stranded in the DMV? We're on the way. Day or night, rain or shine.
        </p>
        <a href="tel:3012549338" className="inline-flex items-center justify-center mt-8 bg-white text-[#822433] hover:bg-gray-100 font-black text-lg px-10 py-4 rounded transition-colors duration-200" data-id="element-992">
          Call Now: (301) 254-9338
        </a>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-993">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-994">
          <div data-id="element-995">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-996">
              We Come to You — Anywhere in the DMV
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-997">
              Tire emergencies don't wait for business hours. That's why
              Ameritech Tires offers 24/7 emergency roadside assistance across
              the entire DMV area — Maryland, DC, and Northern Virginia. One
              call and we're on our way.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-998">
              Our roadside team carries the equipment to handle flat tires,
              blowouts, and tire-related emergencies on the spot. We'll get you
              safely back on the road or tow your vehicle to the nearest
              Ameritech location for full service.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-999">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1000">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1001">
              <li className="flex items-start gap-3" data-id="element-1002">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1003" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1004">
                  24/7 availability — 365 days a year
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1005">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1006" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1007">
                  Full DMV area coverage (MD, DC, Northern VA)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1008">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1009" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1010">
                  On-site flat tire repair or spare tire installation
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1011">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1012" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1013">
                  Emergency tire replacement from mobile inventory
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1014">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1015" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1016">
                  Towing to nearest Ameritech location if needed
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1017">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1018" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1019">
                  Fast response times — typically under 45 minutes
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1020">
        <div className="max-w-5xl mx-auto" data-id="element-1021">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1022">
            What to Do When You Have a Blowout
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1023">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1024">
              <div className="w-10 h-10 bg-[#822433] rounded-full flex items-center justify-center text-white font-black text-lg mb-4" data-id="element-1025">
                1
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1026">
                Stay Calm &amp; Pull Over
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1027">
                Grip the wheel firmly, ease off the gas, and steer to the
                shoulder. Don't brake hard.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1028">
              <div className="w-10 h-10 bg-[#822433] rounded-full flex items-center justify-center text-white font-black text-lg mb-4" data-id="element-1029">
                2
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1030">
                Turn on Hazard Lights
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1031">
                Make yourself visible to other drivers. Stay in your vehicle if
                it's safe to do so.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1032">
              <div className="w-10 h-10 bg-[#822433] rounded-full flex items-center justify-center text-white font-black text-lg mb-4" data-id="element-1033">
                3
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1034">
                Call Ameritech
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1035">
                Call (301) 254-9338 and we'll dispatch a technician to your
                location immediately.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1036">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1037">
          Stranded? Call Us Now.
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1038">
          Our emergency line is staffed 24/7. We'll be there fast.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1039">
          <a href="tel:3012549338" className="inline-flex items-center justify-center bg-[#822433] hover:bg-[#6B1D29] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1040">
            Call (301) 254-9338
          </a>
          <Link to="/locations" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1041">
            Find a Location
          </Link>
        </div>
      </section>
    </div>;
}